import React from 'react';
import { Mail, Phone, WhatsApp } from 'src/assets/images';
import { xLinkContacts } from 'src/common';
import { Button, Modal } from 'src/features/common';
import { useHistory } from 'react-router-dom';
import {
  ButtonParamType,
  DefaultButtonStyle,
} from 'src/features/common/components/button/revamp-button';
import { paymentsDashboardRoute } from 'src/routing/routes';

const customerCare = [
  {
    contact: xLinkContacts.number,
    contactType: 'Phone',
    link: xLinkContacts.numberUrl,
    icon: Phone,
  },
  {
    contact: xLinkContacts.whatsapp,
    contactType: 'WhatsApp',
    link: xLinkContacts.whatsappUrl,
    icon: WhatsApp,
  },
  {
    contact: xLinkContacts.email,
    contactType: 'Email',
    link: xLinkContacts.emailUrl,
    icon: Mail,
  },
];

interface Props {
  visible: boolean;
  onClose: () => void;
}

export function GeneratePaymentRequestModal(props: Props) {
  const history = useHistory();
  return (
    <Modal visible={props.visible} size="small">
      <section className="grid gap-10 text-center text-grey-600">
        <div className="md:px-20">
          <h1 className="text-base font-medium md:text-4xl">Payment Request Activation</h1>
          <p className="mt-2 text-xs !font-normal md:text-lg text-grey-400">
            Please contact customer care and we’ll help you to activate the payment request.
          </p>
        </div>

        <div className="text-grey-600">
          <h1 className="text-base font-medium md:px-20 md:text-2xl">
            Vodacom Payment Services Customer Care
          </h1>
          <div className="flex justify-between mt-5">
            {customerCare.map((customer, idx) => (
              <div key={idx}>
                <img className="text-grey-600" src={customer.icon} alt={customer.contactType} />
                <p className="text-xs font-bold md:text-base">{customer.contactType}</p>
                <a
                  href={customer.link}
                  className="text-xs underline lowercase md:text-base text-grey-600"
                >
                  {customer.contact}
                </a>
              </div>
            ))}
          </div>
        </div>

        <Button
          type={'submit'}
          buttonStyle={DefaultButtonStyle()
            .hasPrimaryAction()
            .isMediumSize()
            .hasLightMode()
            .build()}
          buttonParams={{
            type: ButtonParamType.NormalButton,
            onClick: () => {
              history.push(paymentsDashboardRoute);
              props.onClose();
            },
          }}
          className="w-56"
          automationid={`DA_Continue_Button`}
        >
          Okay!
        </Button>
      </section>
    </Modal>
  );
}
